/* SofaSavior Theme – Varianten, Warenkorb (Shopify AJAX API), Galerie, Vorher/Nachher */
(() => {
  const T = window.SofaTheme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Geldformat (Shopify money_format) ---------- */
  function money(cents) {
    return ((cents || 0) / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
  }

  function toast(msg) {
    const el = $("#toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("show");
    clearTimeout(toast.t);
    toast.t = setTimeout(() => el.classList.remove("show"), 3200);
  }

  /* ---------- Produkt & Varianten ---------- */
  const productJson = $("#ProductJson");
  const form = $("#ProductForm");
  let product = null, variant = null;

  if (productJson && form) {
    product = JSON.parse(productJson.textContent);
    const variantInput = $("#variantId");
    variant = product.variants.find((v) => String(v.id) === variantInput.value) || product.variants[0];
    const unitIdx = product.options.findIndex((o) => (o.name || o) === (T.unitOption || "Länge"));

    const selected = () => $$(".opt", form).map((fs) => {
      const on = $('.chip[aria-pressed="true"]', fs);
      return on ? on.dataset.value : null;
    });

    function renderVariant() {
      if (!variant) return;
      variantInput.value = variant.id;
      $("#price").textContent = money(variant.price);
      const cmp = $("#comparePrice");
      if (cmp) {
        const show = variant.compare_at_price && variant.compare_at_price > variant.price;
        cmp.hidden = !show;
        cmp.textContent = show ? money(variant.compare_at_price) : "";
      }
      const unit = $("#unitPrice");
      if (unit) {
        const meters = unitIdx >= 0 ? parseFloat(String(variant.options[unitIdx]).replace(",", ".")) : NaN;
        unit.textContent = meters > 0 ? `(${money(Math.round(variant.price / meters))} / m)` : "";
      }
      const btn = $("#addToCart");
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? "In den Warenkorb" : "Ausverkauft";
      if ($("#stickyPrice")) $("#stickyPrice").textContent = money(variant.price);
      if ($("#stickyVariant")) $("#stickyVariant").textContent = variant.title;
      if (variant.featured_media && variant.featured_media.preview_image) {
        $("#mainImg").src = variant.featured_media.preview_image.src;
      }
      const url = new URL(location.href);
      if (url.pathname.includes("/products/")) {
        url.searchParams.set("variant", variant.id);
        history.replaceState(null, "", url);
      }
    }

    $$(".opt", form).forEach((fs) => {
      fs.addEventListener("click", (e) => {
        const b = e.target.closest(".chip");
        if (!b) return;
        $$(".chip", fs).forEach((c) => c.setAttribute("aria-pressed", c === b));
        $("[data-option-label]", fs).textContent = b.dataset.value;
        const opts = selected();
        variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
        if (!variant) {
          const btn = $("#addToCart");
          btn.disabled = true;
          btn.textContent = "Nicht verfügbar";
          return;
        }
        renderVariant();
      });
    });
    renderVariant();

    const qty = $("#qty");
    const setQty = (n) => { qty.value = Math.max(1, Math.min(99, n || 1)); };
    $("#qtyMinus").onclick = () => setQty(+qty.value - 1);
    $("#qtyPlus").onclick = () => setQty(+qty.value + 1);

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = $("#addToCart");
      btn.disabled = true;
      try {
        const res = await fetch(T.routes.cartAdd + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: Number(qty.value) || 1 }] }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Fehler");
        await refreshCart();
        openCart();
      } catch (err) {
        toast(err.message || "Konnte nicht hinzugefügt werden.");
      } finally {
        btn.disabled = !variant || !variant.available;
      }
    });

    const sticky = $("#sticky");
    if ($("#stickyAdd")) $("#stickyAdd").onclick = () => form.requestSubmit();
    if (sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => {
        sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe($("#addToCart"));
    }
  }

  /* ---------- Galerie ---------- */
  $$(".thumb").forEach((t) => {
    t.addEventListener("click", () => {
      $$(".thumb").forEach((x) => x.classList.toggle("is-active", x === t));
      $("#mainImg").src = t.dataset.src;
      $("#mainImg").alt = t.dataset.alt || "";
    });
  });

  /* ---------- Warenkorb-Drawer ---------- */
  const MINUS = '<svg class="i" viewBox="0 0 24 24"><path d="M5 12h14"/></svg>';
  const PLUS = '<svg class="i" viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
  const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  function renderCart(cart) {
    const count = $("#cartCount");
    if (count) { count.textContent = cart.item_count; count.dataset.n = cart.item_count; }
    document.body.classList.toggle("cart-empty", cart.item_count === 0);

    $("#lines").innerHTML = cart.items.map((it) => `
      <li class="line">
        ${it.image ? `<img src="${esc(it.image + (it.image.includes("?") ? "&" : "?") + "width=160")}" alt="">` : "<span></span>"}
        <div>
          <div class="line__title">${esc(it.product_title)}</div>
          ${it.product_has_only_default_variant ? "" : `<div class="line__meta">${esc(it.variant_title)}</div>`}
          <div class="line__qty">
            <button data-key="${it.key}" data-q="${it.quantity - 1}" aria-label="Weniger">${MINUS}</button>
            <span>${it.quantity}</span>
            <button data-key="${it.key}" data-q="${it.quantity + 1}" aria-label="Mehr">${PLUS}</button>
          </div>
        </div>
        <div class="line__right">
          <span class="line__price">${money(it.final_line_price)}</span>
          <button class="line__remove" data-key="${it.key}" data-q="0">Entfernen</button>
        </div>
      </li>`).join("");

    $("#subtotal").textContent = money(cart.items_subtotal_price);
    $("#discountRow").style.display = cart.total_discount > 0 ? "" : "none";
    $("#discount").textContent = "−" + money(cart.total_discount);
    $("#total").textContent = money(cart.total_price);

    const free = T.freeShippingFrom || 0;
    const missing = free - cart.total_price;
    $("#shipBar").style.display = free > 0 ? "" : "none";
    $("#shipText").innerHTML = missing > 0
      ? `Noch <strong>${money(missing)}</strong> bis zum kostenlosen Versand`
      : "Ihre Bestellung wird <strong>kostenlos</strong> versendet";
    $("#shipFill").style.width = Math.min(100, (cart.total_price / free) * 100) + "%";
  }

  async function refreshCart() {
    const res = await fetch(T.routes.cart + ".js", { headers: { Accept: "application/json" } });
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  function openCart() {
    document.body.classList.add("cart-open");
    $("#drawer").setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    document.body.classList.remove("cart-open");
    $("#drawer").setAttribute("aria-hidden", "true");
  }

  if ($("#drawer")) {
    refreshCart().catch(() => {});
    $("#openCart").addEventListener("click", (e) => { e.preventDefault(); refreshCart().catch(() => {}); openCart(); });
    $("#closeCart").onclick = closeCart;
    $("#drawerBg").onclick = closeCart;
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeCart(); });
    $("#lines").addEventListener("click", async (e) => {
      const b = e.target.closest("button[data-key]");
      if (!b) return;
      b.disabled = true;
      const res = await fetch(T.routes.cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: b.dataset.key, quantity: Math.max(0, Number(b.dataset.q)) }),
      });
      if (res.ok) renderCart(await res.json());
      else toast("Menge konnte nicht geändert werden.");
    });
  }

  /* ---------- Vorher/Nachher-Regler ---------- */
  $$(".ba").forEach((ba) => {
    const range = $(".ba__range", ba);
    const setPos = (p) => {
      p = Math.max(0, Math.min(100, p));
      ba.style.setProperty("--pos", p + "%");
      if (range) range.value = Math.round(p);
    };
    const fromEvent = (e) => {
      const r = ba.getBoundingClientRect();
      setPos(((e.clientX - r.left) / r.width) * 100);
    };
    let dragging = false;
    ba.addEventListener("pointerdown", (e) => {
      dragging = true;
      try { ba.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
    });
    ba.addEventListener("pointermove", (e) => { if (dragging) fromEvent(e); });
    ba.addEventListener("pointerup", () => { dragging = false; });
    ba.addEventListener("pointercancel", () => { dragging = false; });
    if (range) range.addEventListener("input", () => setPos(Number(range.value)));
  });
})();
